import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { IConfirmationDialog } from "../../interfaces";

export const SendDiscrepanciesDialog: React.FC<IConfirmationDialog> = ({
    open,
    handleClose,
    ...props
}: IConfirmationDialog) => {

    return <Dialog
        open={open}
        maxWidth="xs"
        fullWidth={true}
        onClose={handleClose}
    >
        <DialogTitle>Send Discrepancies?</DialogTitle>

        <DialogContent>
            <DialogContentText>
                You can only send discrepancies to the requestor once.
                You will not be able to amend discrepancies after they have been sent.
            </DialogContentText>
        </DialogContent>

        <DialogActions>
            <Button color="warning" onClick={() => handleClose(false)}>Dont Send</Button>
            <Button color="primary" onClick={() => handleClose(true)}>Send</Button>
        </DialogActions>
    </Dialog>
}